import React from 'react';
import ExternalRoutes from 'services/external_routes';
import LoginForm from 'components/molecules/login_form';
import LoginFlashMessageNotification from 'components/molecules/login-flash-message-notification';
import LogoCnl from 'assets/images/logo-conlicita-branca.svg';
import * as S from './styles';

const LoginPage = () => {
  return (
    <S.Body className="d-flex flex-column h-100">
      <div className="login-bar text-white mb-2">
        <S.Container>
          <div className="row">
            <div className="col-lg-7 col-12 logo d-flex align-items-center justify-content-center justify-content-lg-start py-3">
              <img src={LogoCnl} alt="Logo ConLicitação" />
              <div className="separator" />
              <span>Tudo sobre licitações públicas</span>
            </div>
            <div className="contact col-lg-5 col-12 d-flex align-items-center justify-content-center justify-content-lg-end mt-lg-0 py-1">
              {`Dúvidas? `}
              <a href={ExternalRoutes.login.contato}>Entre em contato</a>
              {` ou ligue 0800 11 14133`}
            </div>
          </div>
        </S.Container>
      </div>
      <LoginFlashMessageNotification />
      <div className="flex-grow-1 align-content-center">
        <LoginForm />
      </div>
    </S.Body>
  );
};

export default LoginPage;
